import videoFeedTypes from './videoFeedTypes';

const { REEL } = videoFeedTypes;

const getEmbedUrl = (data, config, lang = 'en') => {

    const clipSlug = data?.slug;
    if (!clipSlug) return '';
    const embedConfig = config?.shareConfig?.embedCode;
    const pathConfig = embedConfig?.path || {};
    const isReelFeed = data?.feeds?.[0]?.type === REEL;
    const path = isReelFeed
        ? pathConfig.reel || 'mlbfilmroom'
        : pathConfig.default || 'm';

    const templateUrl = embedConfig?.src || 'https://streamable.com/{path}/{slug}';
    const embedUrl = `${templateUrl.replace('{path}', path).replace('{slug}', clipSlug)}${lang.toLowerCase() !== 'en' ? `?lang=${lang}` : ''}`;

    return embedUrl;

};

export default getEmbedUrl;
